import React, { Component } from "react"

class StatusIndicator extends Component {
    constructor(){
        super()
    }

    render() {
        const {status, rrsdoc, poNo}=this.props
        let step1CSS=""
        let step2CSS=""
        let step3CSS=""
        let step4CSS=""
        let step1Text="Creation"
        let step2Text="Review"
        let step3Text="Accept"
        let step4Text="Completed"  
        switch(status){
            case "DRAF" : {
                //Draft
                step1CSS="active"
                step2CSS=""
                step3CSS=""
                step4CSS=""

                break
            }
            case "REJT" : {
                //Draft
                step1CSS="active"
                step2CSS=""
                step3CSS=""
                step4CSS=""

                break
            }
            case "DECL" : {
                //Draft
                step1CSS="active"
                step2CSS=""
                step3CSS=""
                step4CSS=""

                break
            }
            case "WVER" : {
                //Waiting for Verification
                step1CSS="done"
                step2CSS="active"
                step3CSS=""
                step4CSS=""
                break
            }
            case "VERI" : {
                //Verifying
                step1CSS="done"
                step2CSS="active"
                step3CSS=""
                step4CSS=""
                break
            }
            case "WACCEPT" : {
                //Waiting  for Accept
                step1CSS="done"
                step2CSS="done"
                step3CSS="active"
                step4CSS=""
                break
            }
            case "MCFM" : {
                //Verifying
                step1CSS="done"
                step2CSS="done"
                step3CSS="active"
                step4CSS=""
                break
            }
            
            case "ACCEPT" : {
                //Verifying
                step1CSS="done"
                step2CSS="done"
                step3CSS="done"
                step4CSS="active"
                break
            }            
            case "BCFM" : {
                //Automaticaly process
                step1CSS="done"
                step2CSS="done"
                step3CSS="done"
                step4CSS="active"
                break
            }
            case "BCOM" : {
                //BOT Completed
                step1CSS="done"
                step2CSS="done"
                step3CSS="done"
                step4CSS="active"
                break
            }
            case "MCOM" : {
                //Manual Completed
                step1CSS="done"
                step2CSS="done"
                step3CSS="done"
                step4CSS="active"
                break
            }
            case "BPCO" : {
                //BOT Partial Completed
                step1CSS="done"
                step2CSS="done"
                step3CSS="done"
                step4CSS="active"
                break
            }
            case "BINC" : {
                //BOT Incomplete
                step1CSS="done"
                step2CSS="done"
                step3CSS="done"
                step4CSS="active"
                break
            }

            case "MCFM" : {
                //Manually process
                step1CSS="done"
                step2CSS="active"
                step3CSS=""
                step4CSS=""
                break
            }
            case "BPRO" : {
                //BOTREAD
                step1CSS="done"
                step2CSS="done"
                step3CSS="done"
                step4CSS="active"
                break
            }
            case "PCOM" : {
                //BOT Completed
                step1CSS="done"
                step2CSS="done"
                step3CSS="done"
                step4CSS="done"
                //step2Text="Completed"
                break
            }
            case "COMPLETE" : {
                //BOT Completed
                step1CSS="done"
                step2CSS="done"
                step3CSS="done"
                step4CSS="done"
                //step2Text="Completed"
                break
            }
            
            default :{
                step1CSS=""
                step2CSS=""
                step3CSS=""
                step4CSS=""
            }
        }

        // step1CSS="done"
        // step2CSS="done"
        // step3CSS="done"
        // step4CSS="done"
        // step2Text="Completed"
	
        return (
            <div className="sp-page-result-container">
                <div className="sp-step-indicator-wrap row justify-content-center">
                    {/* <div className="sp-step-indicator-panel text-right col-md-1 col-xl-2"></div> */}
                    <div className="sp-step-indicator-panel col-md-10 col-xl-8">
                        <ul className="sp-step-indicator">
                            <li className={"sp-indicator-step sp-indicator-step1 " + step1CSS}>
                                <div className="indicator-icon" />
                                <div className="sp-indicator-step-label">{step1Text}</div>
                            </li>
                            <li className={"sp-indicator-step sp-indicator-step2 " + step2CSS}>
                                <div className="indicator-icon" />
                                <div className="sp-indicator-step-label">{step2Text}</div>
                            </li>
                            <li className={"sp-indicator-step sp-indicator-step2 " + step3CSS}>
                                <div className="indicator-icon" />
                                <div className="sp-indicator-step-label">{step3Text}</div>
                            </li>
                            <li className={"sp-indicator-step sp-indicator-step2 " + step4CSS}>
                                <div className="indicator-icon" />
                                <div className="sp-indicator-step-label">{step4Text}</div>
                            </li>
                        </ul>
                    </div>
                    {/* <div className="sp-step-indicator-panel text-right col-md-3 col-xl-4" style={{ paddingTop: '30px' }}>
                        {rrsdoc ? <div className="rrs-detail-data" style={{ fontSize: '1.5rem' }} >RRS Doc No. : {rrsdoc}</div> : null}
                        {poNo ? <div className="rrs-detail-data" style={{ fontSize: '1.5rem' }}>PO/Contract No. : {poNo}</div> : null}
                    </div> */}
                </div>
            </div>
        )
    }
}

export default StatusIndicator
